import { handleApiError, handleApiResponse } from "../utils/utils";
import { ApiClient } from "./apiConfig";

export const getPackages = async ({ offset, limit, query }) => {
  try {
    const resp = await ApiClient.get("/packages/all", {
      params: { page: offset, page_size: limit, query: query },
    });
    const result = handleApiResponse(resp);
    return result;
  } catch (err) {
    console.log(err);
    handleApiError(err);
  }
};
export const getPackagesList = async () => {
  try {
    const resp = await ApiClient.get("/packages/list");
    const result = handleApiResponse(resp);
    return result;
  } catch (err) {
    console.log(err);
    handleApiError(err);
  }
};

export const createPackage = async (values) => {
  try {
    const resp = await ApiClient.post("/packages/package", values);
    const result = handleApiResponse(resp);
    return result;
  } catch (err) {
    console.log(err);
    handleApiError(err);
  }
};

export const getPackageById = async ({ id }) => {
  try {
    const resp = await ApiClient.get("/packages/package", {
      params: { id: id },
    });
    const result = handleApiResponse(resp);
    return result;
  } catch (err) {
    console.log(err);
    handleApiError(err);
  }
};

export const updatePackage = async (values) => {
  try {
    const resp = await ApiClient.put("/packages/package", values);
    const result = handleApiResponse(resp);
    return result;
  } catch (err) {
    console.log(err);
    handleApiError(err);
  }
};
